import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Toast } from "primereact/toast";
import { InputSwitch } from "primereact/inputswitch";

import { runMorningSync, getSyncStatus } from "../../offline/syncService";
import { getRegId } from "../../offline/regId";
import { useOfflineMode } from "../../offline/offlineMode";

import * as offlineCatalogo from "../../offline/offlineCatalogoService";

export default function OfflineSyncPage() {
  const toast = useRef(null);

  const [syncing, setSyncing] = useState(false);
  const [progress, setProgress] = useState(null);
  const [status, setStatus] = useState([]);
  const [offlineMode, setOfflineMode] = useOfflineMode();

  const loadStatus = async () => {
    const rows = await getSyncStatus();
    setStatus(rows);
  };

  useEffect(() => {
    loadStatus();
  }, []);

  useEffect(() => {
    window.offlineCatalog = offlineCatalogo;
  }, []);

  const handleSync = async () => {
    if (syncing) return;

    setSyncing(true);
    setProgress(null);

    try {
      const total = await runMorningSync(setProgress);

      toast.current.show({
        severity: "success",
        summary: "Sincronización completa",
        detail: `Servicios sincronizados: ${total}`,
        life: 4000,
      });

      await loadStatus();
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error de sincronización",
        detail: error.message,
        life: 6000,
      });
    } finally {
      setSyncing(false);
    }
  };

  const progressValue = progress?.total
    ? Math.round((progress.actual / progress.total) * 100)
    : 0;

  return (
    <div className="p-4">
      <Toast ref={toast} />

      <div className="surface-card p-4 shadow-2 border-round-xl">
        <div className="flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="m-0">Modo offline</h2>
            <p className="text-600 mb-0">
              Sincroniza los datos maestros para trabajar sin conexión.
            </p>
          </div>

          <div className="flex align-items-center gap-2">
            <span className="font-medium">
              {offlineMode ? "Offline activado" : "Online"}
            </span>
            <InputSwitch
              checked={offlineMode}
              onChange={(e) => setOfflineMode(e.value)}
            />
          </div>
        </div>

        <div className="mb-4">
          <strong>RegId dispositivo:</strong>
          <div className="text-600 mt-1">{getRegId()}</div>
        </div>

        <Button
          label={syncing ? "Sincronizando..." : "Sincronizar datos"}
          icon={syncing ? "pi pi-spin pi-spinner" : "pi pi-refresh"}
          disabled={syncing}
          onClick={handleSync}
        />

        {progress && (
          <div className="mt-4">
            <div className="mb-2">
              {progress.nombre} - {progress.estado}
            </div>
            <ProgressBar value={progressValue} />
          </div>
        )}

        <h3 className="mt-5">Estado de sincronización</h3>

        <div className="flex flex-column gap-2">
          {status.length === 0 && (
            <span className="text-600">Todavía no hay sincronizaciones.</span>
          )}

          {status.map((item) => (
            <div
              key={item.recurso}
              className="p-3 border-1 surface-border border-round"
            >
              <div className="font-bold">{item.recurso}</div>
              <div>Estado: {item.estado}</div>
              <div>Última sync: {item.ultimaSync || "-"}</div>
              <div>Registros: {item.cantidadRegistros ?? "-"}</div>
              {item.ultimoError && (
                <div className="text-red-500">Error: {item.ultimoError}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
